import React, { useState, useEffect } from "react";
import * as helper                    from "../global/Helper";
import faqIcon from "../../assets/images/question.png";

const FaqTable = (props) => {
  
  const [allFAQs, setallFAQs] = useState(props.allFAQs);
  const [showRemoveSearch, setshowRemoveSearch] = useState(false);

  const {
    editFAQHandler,
    toggleFAQStatus
  } = props;

  const searchHandler = ({target}) => {
    if (target.value === "") {
      setshowRemoveSearch(false);
      return setallFAQs(props.allFAQs);
    }

    setshowRemoveSearch(true);
    const matchedFaq = props.allFAQs.filter((t)=>{
      let matchFAQ = `${t.Question} ${t.Answer}`;
      let matchFound = 0;

      const searchArr = target.value.split(' ');
      searchArr.forEach(element => {
        matchFound += matchFAQ.toLowerCase().includes(element.toLowerCase()) ? 1 : 0;
      });
      return matchFound === searchArr.length;
    });
    setallFAQs(matchedFaq);
  }

  const clearSearchHandler = () =>{ 
    $("#generalSearch").val("");
    setshowRemoveSearch(false);
    return setallFAQs(props.allFAQs);
  }

  useEffect(() => {
    helper.SetScrollHeight();
  });

  return (
    <div className="kt-form kt-form--label-right kt-margin-b-10">
      <div className="row align-items-center stickyFilter">
        <div className="col-xl-12 order-2 order-xl-1">
          <div className="row align-items-center">
            <div className="col-md-4 kt-margin-b-20-tablet-and-mobile margin-b0">
              <div className="kt-input-icon kt-input-icon--left">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search FAQ..."
                  id="generalSearch"
                  onChange={searchHandler}>
                </input>
                <span className="kt-input-icon__icon kt-input-icon__icon--left">
                  <span>
                    <i className="la la-search"></i>
                  </span>
                </span>
                {showRemoveSearch && (
                  <span className="kt-input-icon__icon kt-input-icon__icon--right">
                      <span onClick={clearSearchHandler}>
                          <i className="la la-close"></i>
                      </span>
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {allFAQs.length > 0 ? (
        <div className="row">
          <div className="col-sm-12">
            <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--scroll kt-datatable--loaded margin-b0">
              <table className="kt-datatable__table">
                <thead className="kt-datatable__head" style={{ display: "block" }}>
                  <tr className="kt-datatable__row block-row">
                    <th className="kt-datatable__cell text-clip" width="80%">
                      <span>FAQ</span>
                    </th> 
                    <th className="kt-datatable__cell--right kt-datatable__cell padding-l50" width="20%">
                      <span className="margin-r40">Action</span>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div
              className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--scroll kt-datatable--loaded scrolTable" onScroll={helper.setStickyHeader}>
              <table className="kt-datatable__table table-striped">
                <tbody
                  className="kt-datatable__body" style={{ display: "block" }}>
                  {allFAQs
                  .map((t, i) => {
                    return (
                      <tr key={i} className="kt-datatable__row block-row clickable">
                        <td width="80%" title={t.Question} className="kt-datatable__cell text-clip">
                          <div className="kt-user-card-v2">
                            <div className="kt-user-card-v2__pic mr-2">
                              <img className="faqIcon" src={faqIcon} alt={t.Question} />
                            </div>              
                            <div className="kt-user-card-v2__details text-clip">
                              <span className="kt-user-card-v2__name text-clip">
                                  {t.Question}
                              </span>
                              <span className="kt-user-card-v2__desc text-clip">
                                {t.Answer}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td
                          className="kt-datatable__cell lucid"
                          width="20%">
                          <button
                            type="button"
                            className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs margin-r10"
                            onClick={() => editFAQHandler(t,i)}>
                            <i className="flaticon2-edit"></i>  
                          </button>
                          <span className="kt-switch kt-switch--icon padding-l10 padding-t5 ">
                            <label>
                              <input
                                type="checkbox"
                                name=""
                                defaultChecked={
                                  t.Active === "Y" ? "checked" : ""
                                }
                                onChange={() => toggleFAQStatus(t)}
                              />
                              <span></span>
                            </label>
                          </span> 
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <span className="empty-table-message">No FAQ Found</span>
      )}
    </div>
  );
};

export default FaqTable;
